module.exports = __webpack_public_path__ + "img/plan1.b63a1110.png";